import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 143306 123849"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#000;stroke-width:1588.08}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528237931136">
        <path
          d="M134403 6129H8901c-544 0-984-442-984-985 0-544 440-984 984-984h125502c544 0 986 440 986 984 0 543-442 985-986 985z"
          className="fill stroke1"
          style={{
            strokeWidth: 1588.08,
          }}
        />
        <path
          d="M5144 2764c-1313 0-2383 1067-2383 2380 0 1315 1070 2382 2383 2382s2382-1067 2382-2382c0-1313-1069-2380-2382-2380zm0 6731c-2397 0-4350-1951-4350-4351 0-2397 1953-4350 4350-4350 2400 0 4349 1953 4349 4350 0 2400-1949 4351-4349 4351zM138163 2764c-1315 0-2383 1067-2383 2380 0 1315 1068 2382 2380 2382 1316 0 2383-1067 2383-2382 0-1313-1067-2380-2380-2380zm0 6731c-2399 0-4352-1951-4352-4351 0-2397 1953-4350 4349-4350 2401 0 4352 1953 4352 4350 0 2400-1951 4351-4349 4351zM19665 123055c-4091 0-7296-1488-7296-3389V7392c0-544 673-983 1505-983 833 0 1507 439 1507 983v112274c0 671 1831 1422 4284 1422s4283-751 4283-1422V7392c0-544 676-983 1505-983 832 0 1507 439 1507 983v112274c0 1901-3203 3389-7295 3389z"
                    className="fill stroke1"
          style={{
            strokeWidth: 1588.08,
          }}

        />
        <path
          d="M31405 110613c-1828 0-3568-279-4902-792-1517-581-2390-1430-2390-2330V7315c0-500 673-906 1505-906 831 0 1504 406 1504 906v100176c0 267 363 559 997 800 841 323 2040 509 3286 509 2451 0 4283-690 4283-1309l2-100176c0-500 671-906 1505-906 827 0 1504 406 1504 906v100176c0 1751-3205 3122-7294 3122z"
                    className="fill stroke1"
          style={{
            strokeWidth: 1588.08,
          }}

        />
        <path
          d="M45987 123055c-4091 0-7296-1488-7296-3389V7392c0-544 673-983 1505-983 833 0 1507 439 1507 983v112274c0 671 1832 1422 4284 1422 2453 0 4283-751 4283-1422V7392c0-544 676-983 1505-983 832 0 1507 439 1507 983v112274c0 1901-3203 3389-7295 3389zM72310 123055c-4092 0-7297-1488-7297-3389V7392c0-544 673-983 1505-983 833 0 1507 439 1507 983v112274c0 671 1832 1422 4285 1422s4282-751 4282-1422V7392c0-544 676-983 1505-983 832 0 1507 439 1507 983v112274c0 1901-3203 3389-7294 3389zM98632 123055c-4091 0-7297-1488-7297-3389V7392c0-544 673-983 1505-983 834 0 1507 439 1507 983v112274c0 671 1832 1422 4285 1422s4282-751 4282-1422V7392c0-544 676-983 1505-983 832 0 1507 439 1507 983v112274c0 1901-3203 3389-7294 3389z"
                    className="fill stroke1"
          style={{
            strokeWidth: 1588.08,
          }}

        />
        <path
          d="M58498 110613c-1827 0-3568-279-4901-792-1518-581-2391-1430-2391-2330V7315c0-500 673-906 1505-906 831 0 1504 406 1504 906v100176c0 267 363 559 997 800 842 323 2040 509 3286 509 2451 0 4283-690 4283-1309l2-100176c0-500 671-906 1505-906 827 0 1505 406 1505 906v100176c0 1751-3206 3122-7295 3122zM85591 110613c-1827 0-3568-279-4901-792-1518-581-2391-1430-2391-2330V7315c0-500 673-906 1505-906 831 0 1505 406 1505 906v100176c0 267 362 559 996 800 842 323 2040 509 3286 509 2451 0 4283-690 4283-1309l2-100176c0-500 671-906 1505-906 827 0 1505 406 1505 906v100176c0 1751-3206 3122-7295 3122zM110600 110613c-1827 0-3567-279-4901-792-1517-581-2391-1430-2391-2330V7315c0-500 673-906 1505-906s1505 406 1505 906v100176c0 267 362 559 996 800 842 323 2040 509 3286 509 2451 0 4283-690 4283-1309l2-100176c0-500 671-906 1505-906 827 0 1505 406 1505 906v100176c0 1751-3206 3122-7295 3122z"
                    className="fill stroke1"
          style={{
            strokeWidth: 1588.08,
          }}

        />
        <path
          d="M123641 123055c-4091 0-7297-1488-7297-3389V7392c0-544 673-983 1505-983 834 0 1507 439 1507 983v112274c0 671 1832 1422 4285 1422s4282-751 4282-1422V7392c0-544 676-983 1505-983 832 0 1507 439 1507 983v112274c0 1901-3203 3389-7294 3389z"
                    className="fill stroke1"
          style={{
            strokeWidth: 1588.08,
          }}

        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
